// JavaScript Document
// Version: 1.0.0

var qrEditorItems = [];
var QRCodeEnabled = false;



jQuery(document).ready(function($) {
	var imprintMainCtx = getImprintMainCtx();

	/**
	 * Gestisce i pulsanti associati ad un QR code.
	 *
	 * @since 1.0.0
	 */
	var qrCodeCta = false;

	if ( $('body').hasClass('desktop') ) {
		imprintMainCtx.on('mouseenter', '.qrcodes-grid .item', function() {
			$(this).addClass('active');
		});

		$(document).on('mouseleave', '.qrcodes-grid .item', function() {
			$(this).removeClass('active');
		});
	} else {
		imprintMainCtx.on('click', '.qrcodes-grid .item', function() {
			$('.qrcodes-grid .item').removeClass('active');

			if ( !qrCodeCta ) {
				$(this).addClass('active');
			} else {
				qrCodeCta = false;
			}

			$('.actions .btn', $(this)).focusout();
		});
	}



	/**
	 * Gestisce il download di un QR code.
	 *
	 * @since 1.0.0
	 */
	imprintMainCtx.on('click', '.qrcodes-grid .item.active .btnDownload', function() {
		var that       = $(this);
		var item       = that.closest('.item');
		var imageUrl   = $('img', item).attr('src');
		var fileName   = imageUrl.substr(imageUrl.lastIndexOf('/') + 1);
		var fileExt    = fileName.substr(fileName.lastIndexOf('.') + 1);
		var mimeTypes  = {
			jpeg: 'image/jpeg',
			jpg: 'image/jpeg',
			gif: 'image/gif',
			png: 'image/png'
		};
		var request    = new XMLHttpRequest();

		item.removeClass('active');

		qrCodeCta = true;

		request.open('GET', imageUrl, true);

		request.responseType = 'blob';
		request.onload       = function(e) {
			download(request.response, fileName, fileName);
		}

		request.send();
	});



	/**
	 * Gestisce la selezione di un QR code.
	 *
	 * @since 1.0.0
	 */
	imprintMainCtx.on('click', '.qrcodes-grid .item.active .btnUpdate', function() {
		var that         = $(this);
		var item         = that.closest('.item');
		var ctx          = getPrintAreaParentTabCtx(that);
		var imageUrl     = $('img', item).attr('src');
		var selectionCtx = getQRcodeSelectionCtx(ctx);

		item.removeClass('active');

		qrCodeCta   = true;

		displayLoading(true, null);
		selectionCtx.fadeOut(400, function() {
			initQREditor('tuning', ctx, imageUrl);

			updateQRCodeStatus(true);
		});
	});


});





/**
 * Inizializza l'editor.
 *
 * @param {string}   type : tipo di editor da inizializzare
 * @param {selector} ctx  : contesto
 * @param {string}   url  : url dell'immagine da caricare nell'editor o base64 dell'immagine stessa
 *
 * @since 1.0.0
 */
function initQREditor(type, ctx, url) {
	switch( type ) {
		case 'tuning':
			var tuningCtx = getQRcodeFineTuningCtx(ctx);

			tuningCtx.fadeIn();
			jQuery('.tuning-container div[class^=col-]', tuningCtx).append('<img src="' + url + '" class="editing-picture" style="display: none;">');

			jQuery('canvas.lowres-canvas', tuningCtx).initQRTuningEditor();
			break;
	}
}



/* SOSTITUITA DA APPENDIMAGE */
/**
 * Aggiunge l'immagine all'area di stampa.
 *
 * @param {string} areaId      : ID dell'area di stanpa
 * @param {string} src         : URL dell'immagine croppata
 * @param {string} componentId : ID del componente
 *
 * @since 1.0.0
 */
function appendQRCode(areaId, src, componentId) {
	var imageCtx            = getPrintAreaTabCtxByAttribute([
		{
			attributeType: 'id',
			attributeValue: 'image-' + areaId,
			dataRelation: '='
		}
	]);
	var imageWidth          = imageCtx.data('area-width');
	var imageHeight         = imageCtx.data('area-height');
	var imageMarginLeft     = imageWidth / 2;
	var previewCtx          = getPreviewPrintAreaCtxByDataAttribute([
		{
			dataAttribute: 'area-id',
			attributeValue: areaId,
			dataRelation: '='
		}
	]);
	var printAreaWidth      = previewCtx.css('width');
	var printAreaHeight     = previewCtx.css('height');
	var containerWidth      = printAreaWidth;
	var containerHeight     = printAreaHeight;
	var containerLeftOffset = '50%';
	var containerTopOffset  = '50%';
	var containerMarginTop  = parseFloat(containerHeight.replace(/[^-\d\.]/g, '')) / -2;
	var attr                = previewCtx.data('image-shift');
	var imageShift          = ( typeof attr !== typeof undefined && attr !== false ) ? parseFloat(attr) : 0;
	var containerMarginLeft = parseFloat(containerWidth.replace(/[^-\d\.]/g, '')) / -2 + imageShift;
	var content             = '';
	var view                = previewCtx.closest('.view').attr('data-view-code');

	// Verifico se esistono più aree di stampa esclusive.
	// Se viene caricata un'immagine in una di esse, l'immagine caricata in precedenza su una delle altre deve essere rimossa.
	var searchCtx           = jQuery('div[data-view-code="' + view + '"]', getPreviewCtx('imprint'));
	var searchPreviewCtx    = getPreviewPrintAreaCtxByDataAttribute([
		{
			dataAttribute: 'area-id',
			attributeValue: areaId,
			dataRelation: '!='
		},
	], searchCtx);

	searchPreviewCtx.each(function(i, el) {
		var printArea = jQuery(el);

		if ( collision(previewCtx, printArea) ) {
			var printAreaId     = printArea.attr('data-area-id');
			var contentToRemove = getPreviewPrintAreaCtxByDataAttribute([
				{
					dataAttribute: 'area-id',
					attributeValue: printAreaId,
					dataRelation: '='
				}
			]);

			contentToRemove.each(function(index, element) {
				getPreviewPrintAreaContentCtx(jQuery(element)).remove();
			});
		}
	});

	content += '<div data-area-id="' + areaId + '" class="print-area-content" style="position:absolute; z-index:201; width:' + containerWidth + '; height:' + containerHeight + '; top:' + containerTopOffset + '; left:' + containerLeftOffset + '; margin-left:' + containerMarginLeft + 'px; margin-top:' + containerMarginTop + 'px;">';
	content += '<img src="' + src + '" style="position:absolute; left:50%; margin-left:-' + imageMarginLeft + 'px; height:auto; width:' + imageWidth + 'px;">';
	content += '</div>';

	previewCtx.html(content);
}



/**
 * Editor per il posizionamento del QR code.
 *
 * @since 1.0.0
 */
(function($){
	$.fn.initQRTuningEditor = function() {

		return this.each(function(index, element) {
			var activeTabpane      = getPrintAreaParentTabCtx($(this));
			var areaId             = activeTabpane.data('area-id');
			var context            = getQRcodeFineTuningCtx(activeTabpane);
			var container          = $('canvas', context).parent();
			var dataAreaHeight 	   = parseFloat(activeTabpane.attr('data-area-height'));
			var dataAreaWidth 	   = parseFloat(activeTabpane.attr('data-area-width'));
			var printAreaObj       = {
				'id': activeTabpane.attr('data-area-id'),
				'width': dataAreaWidth,
				'height': dataAreaHeight,
				'left': $('canvas', context).width() / 2 - dataAreaWidth / 2,
				'top': $('canvas', context).height() / 2 - dataAreaHeight / 2
			};
			var printArea          = $('<div></div>').addClass('print-area');
			var cHeight;
			var gap                = 60;
			var activeImprintPanel = activeTabpane.closest('.imprint-panel.in');

			// Se necessario, aumento l'altezza del canvas per far stare tutta l'area di stampa.
			// In caso contrario, se possibile, ingrandisco l'area di stampa nel canvas per migliorare l'usabilità del logo editor.
			if ( $('canvas', context).height() > dataAreaHeight ) {
				cHeight            = Math.round($('canvas', context).height());
				printAreaObj.scale = ( cHeight - gap ) / printAreaObj.height ;
				// Poiché "printAreaObj.scale" è diverso da 1, devo correggere i valori di "left" e "top".
				printAreaObj.left  = $('canvas', context).width() / 2 - ( dataAreaWidth * printAreaObj.scale / 2 );
				printAreaObj.top   = cHeight / 2 - ( dataAreaHeight * printAreaObj.scale / 2 );
			} else {
				cHeight            = Math.round(printAreaObj.height) + gap;
				printAreaObj.top   = cHeight / 2 - dataAreaHeight / 2;
				printAreaObj.scale = 1;
			}

			var canvas 			 = new fabric.Canvas($('canvas.lowres-canvas', context).attr('id'));
			var scaleFactor;
			var rotation;
			// A partire da FabricJS v.2.0.0 c'è il supporto ai display retina.
			var devicePixelRatio = 1;

			// Hires Canvas variables.
			var hiImageHeight    = minerva_configurator_vars.hi_image_height;
			var lowImageHeight   = minerva_configurator_vars.low_image_height;
			var cf               = hiImageHeight / lowImageHeight;
			var hiresCanvas      = new fabric.Canvas($('canvas.hires-canvas', context).attr('id'));
			var hiresPicture;

			printArea.css('width', printAreaObj.width * printAreaObj.scale);
			printArea.css('height', printAreaObj.height * printAreaObj.scale);
			printArea.css('left', printAreaObj.left);
			printArea.css('top', printAreaObj.top);

			canvas.setDimensions({
				width: container.width(),
				height: cHeight
			});

			qrEditorItems[areaId] = { 'canvas': canvas, 'printArea': printAreaObj };

			$('.tuning-container .canvas-container div.print-area', context).remove();
			$('.tuning-container .canvas-container', context).append(printArea);

			qrEditorItems[areaId].tuningCanvas    = canvas;
			qrEditorItems[areaId].tuningPrintArea = printAreaObj;

			fabric.Image.fromURL($('.editing-picture', context).attr('src'), function(image) {
				image.set({
					borderColor: fabricBorderColor,
					borderScaleFactor: 1,
					cornerColor: fabricCornerColor,
					cornerSize: 8,
					lockRotation: true,
					transparentCorners: false,
					//lockMovementX: true,
					lockScalingX: true,
					lockScalingY: true
				});

				var imageWidth      = image.width;
				var imageHeight     = image.height;
				var canvasWidth     = parseFloat(canvas.width);
				var canvasHeight    = parseFloat(canvas.height);
				var printAreaWidth  = parseFloat(printAreaObj.width);
				var printAreaHeight = parseFloat(printAreaObj.height);
				var rotation        = 0;

				if ( imageWidth > imageHeight ) {
					rotation    = -90;
					scaleFactor = Math.min(printAreaHeight / imageWidth, printAreaWidth / imageHeight) * printAreaObj.scale;
				} else {
					rotation    = 0;
					scaleFactor = Math.min(printAreaWidth / imageWidth, printAreaHeight / imageHeight) * printAreaObj.scale;
				}

				image.scale(scaleFactor);
				image.set({
					left: canvasWidth / 2,
					top: canvasHeight /2,
					originX: "center",
        			originY: "center"
				});
				image.rotate(rotation);
				image.setControlsVisibility({ bl: true, br: true, mb: false, ml: false, mr: false, mt: false, tl: true, tr: true });
				canvas.add(image);

				qrEditorItems[areaId].tuningPicture = image;

				// CANVAS HIRES - START :: Moved here because the hires canvas must be initialized once that scaleFactor is defined.
				hiresCanvas.setDimensions({
					width: canvas.width * cf,
					height: canvas.height * cf
				});

				qrEditorItems[areaId].hiresCanvas = hiresCanvas;

				fabric.Image.fromURL($('.editing-picture', context).attr('src'), function(image) {
					image.scale(scaleFactor * cf);
					image.set({
						left: parseFloat(hiresCanvas.width) / 2,
						top: parseFloat(hiresCanvas.height) /2,
						originX: "center",
						originY: "center"
					});
					image.rotate(rotation);

					hiresCanvas.add(image);
					hiresPicture        = image;
					paHiLeft            = hiresCanvas.width / 2 -  dataAreaWidth * cf  * printAreaObj.scale / 2;
					paHiTop             = hiresCanvas.height / 2 -  dataAreaHeight * cf  * printAreaObj.scale / 2;

					qrEditorItems[areaId].hiresPicture = hiresPicture;

					var printAreaHi     = $('<div></div>').addClass('print-area').addClass('high');

					printAreaHi.css('width', printAreaObj.width * cf * printAreaObj.scale);
					printAreaHi.css('height', printAreaObj.height * cf * printAreaObj.scale);
					printAreaHi.css('left', paHiLeft);
					printAreaHi.css('top', paHiTop);

					$('.hires-tuning-container .canvas-container div.print-area.high', context).remove();
					$('.hires-tuning-container .canvas-container', context).append(printAreaHi);

					// Initial crop and update of the preview
					qrEditorItems[areaId].printAreaHi = {
						left: paHiLeft,
						top: paHiTop,
						width: printAreaObj.width * cf * printAreaObj.scale,
						height: printAreaObj.height * cf * printAreaObj.scale
					};

					// APPLICO SUBITO L'IMMAGINE RUOTATA E RISCALATA ALL'AREA DI STAMPA
					hiresPicture.rotate(qrEditorItems[areaId].tuningPicture.angle);
					hiresPicture.left   = qrEditorItems[areaId].tuningPicture.left * cf;
					hiresPicture.top    = qrEditorItems[areaId].tuningPicture.top * cf;
					hiresPicture.scaleX = qrEditorItems[areaId].tuningPicture.scaleX * cf;
					hiresPicture.scaleY = qrEditorItems[areaId].tuningPicture.scaleY * cf;

					hiresCanvas.renderAll();

					var imageBytes = hiresCanvas.toDataURL({
						left: qrEditorItems[areaId].printAreaHi.left,
						top: qrEditorItems[areaId].printAreaHi.top,
						width: qrEditorItems[areaId].printAreaHi.width,
						height: qrEditorItems[areaId].printAreaHi.height
					});

					if ( printAreaObj.scale != 1 ) {
						var resize     = 1 / printAreaObj.scale;
						var tempImg    = new Image();

						tempImg.src    = imageBytes;
						tempImg.onload = function() {
							var tempCanvas  = new fabric.Canvas(jQuery('<canvas></canvas>')[0]);

							tempCanvas.setDimensions({
								width: tempImg.width * resize,
								height: tempImg.height * resize,
							});

							var imgInstance = new fabric.Image(tempImg, {
								left: 0,
								top: 0
							});

							imgInstance.scale(resize);
							tempCanvas.add(imgInstance);
							tempCanvas.renderAll();
							imageBytes = tempCanvas.toDataURL({
								left: 0,
								top: 0,
								width: tempCanvas.width,
								height: tempCanvas.height
							});

							appendImage(activeTabpane.attr('data-area-id'), imageBytes, 'qrcode');
						};
					} else {
						appendImage(activeTabpane.attr('data-area-id'), imageBytes, 'qrcode');
					}

				});
				// CANVAS HIRES - END

				displayLoading(false, null);
			});


			// UPDATE
			$('.btnUpdateQRcode', context).off('click');
			$('.btnUpdateQRcode', context).on('click', function() {
				displayLoading(true, '');

				var ctx        = getPrintAreaParentTabCtx($(this));
				var areaId     = ctx.data('area-id');
				var multiplier = 1 / devicePixelRatio;

				qrEditorItems[areaId].tuningCanvas.discardActiveObject();

				// CANVAS HIRES - START
				hiresPicture.rotate(qrEditorItems[areaId].tuningPicture.angle);
				hiresPicture.left    = qrEditorItems[areaId].tuningPicture.left * cf;
				hiresPicture.top     = qrEditorItems[areaId].tuningPicture.top * cf;
				hiresPicture.scaleX  = qrEditorItems[areaId].tuningPicture.scaleX * cf;
				hiresPicture.scaleY  = qrEditorItems[areaId].tuningPicture.scaleY * cf;

				hiresCanvas.renderAll();

				var imageBytes = hiresCanvas.toDataURL({
					left: qrEditorItems[areaId].printAreaHi.left,
					top: qrEditorItems[areaId].printAreaHi.top,
					width: qrEditorItems[areaId].printAreaHi.width,
					height: qrEditorItems[areaId].printAreaHi.height
				});

				if ( printAreaObj.scale != 1 ) {
					var resize     = 1 / printAreaObj.scale;
					var tempImg    = new Image();

					tempImg.src    = imageBytes;
					tempImg.onload = function() {
						var tempCanvas  = new fabric.Canvas(jQuery('<canvas></canvas>')[0]);

						tempCanvas.setDimensions({
							width: tempImg.width * resize,
							height: tempImg.height * resize,
						});

						var imgInstance = new fabric.Image(tempImg, {
							left: 0,
							top: 0
						});

						imgInstance.scale(resize);
						tempCanvas.add(imgInstance);
						tempCanvas.renderAll();
						imageBytes = tempCanvas.toDataURL({
							left: 0,
							top: 0,
							width: tempCanvas.width,
							height: tempCanvas.height
						});

						qrTuningUpdateCallback(ctx.attr('data-area-id'), imageBytes, ctx.closest('.imprint-panel').attr('data-component-id'));
					};
				} else {
					qrTuningUpdateCallback(ctx.attr('data-area-id'), imageBytes, ctx.closest('.imprint-panel').attr('data-component-id'));
				}
				// CANVAS HIRES - END

				updateQRCodeStatus(true);
			});


			// CANCEL
			$('.btnCancelQRcode', context).off('click');
			$('.btnCancelQRcode', context).on('click', function() {
				var ctx    = getPrintAreaParentTabCtx($(this));
				var areaId = ctx.data('area-id');

				$('.canvas-container', $('.tuning-container', context)).before($('<canvas id="qrcode-tuning-canvas-' + areaId + '" class="lowres-canvas"></canvas>'));

				qrEditorItems[areaId].tuningCanvas.clear();
				qrEditorItems[areaId].tuningPicture = null;

				// CANVAS HIRES - START
				$('.canvas-container', $('.hires-tuning-container', context)).before($('<canvas id="qrcode-hires-tuning-canvas-' + areaId + '" class="hires-canvas"></canvas>'));
				hiresCanvas.clear();
				// CANVAS HIRES - END

				$('img', $('.canvas-container', context).parent()).remove();
				$('.canvas-container', context).remove();

				context.fadeOut(400, function() {
					//$('.print-area.active .print-area-content').remove();
					removeImage(areaId, 'qrcode');

					$('.qrcode-selection', activeTabpane).fadeIn();
				});

				updateQRCodeStatus(false);
			});

		});
	};
})(jQuery);



/**
 * Azioni da eseguire sull'update del logo editor con i controlli di posizionamento.
 *
 * @param {string} areaId      : ID dell'area di stampa
 * @param {string} imageBytes  : base64 dell'immagine
 * @param {string} componentId : ID del componente
 *
 * @since 1.0.0
 */
function qrTuningUpdateCallback(areaId, imageBytes, componentId) {
	appendImage(areaId, imageBytes, 'qrcode');
	displayLoading(false, null);
	jQuery('#saved-configurations-container').fadeOut();
}



/**
 * Binding degli handler ai vari pulsanti: il bind viene fatto su tutti i "tab-pane" di tutte le aree di stampa.
 *
 * @since 1.0.0
 */
jQuery('document').ready(function($) {
	// DOWN
	$('.qrcode-fine-tuning .btnDown').on('click', function() {
		var areaId = getPrintAreaParentTabCtx($(this)).data('area-id');

		qrEditorItems[areaId].tuningPicture.top = qrEditorItems[areaId].tuningPicture.top += 1;
		qrEditorItems[areaId].tuningCanvas.renderAll();
	});


	// UP
	$('.qrcode-fine-tuning .btnUp').on('click', function() {
		var areaId = getPrintAreaParentTabCtx($(this)).data('area-id');

		qrEditorItems[areaId].tuningPicture.top = qrEditorItems[areaId].tuningPicture.top -= 1;
		qrEditorItems[areaId].tuningCanvas.renderAll();
	});


	// LEFT
	$('.qrcode-fine-tuning .btnLeft').on('click', function() {
		var areaId = getPrintAreaParentTabCtx($(this)).data('area-id');

		qrEditorItems[areaId].tuningPicture.left = qrEditorItems[areaId].tuningPicture.left -= 1;
		qrEditorItems[areaId].tuningCanvas.renderAll();
	});


	// RIGHT
	$('.qrcode-fine-tuning .btnRight').on('click', function() {
		var areaId = getPrintAreaParentTabCtx($(this)).data('area-id');

		qrEditorItems[areaId].tuningPicture.left = qrEditorItems[areaId].tuningPicture.left += 1;
		qrEditorItems[areaId].tuningCanvas.renderAll();
	});

});



/**
 * Aggiorna lo stato del QR code.
 *
 * @param {bool} enable :
 *
 * @since 1.0.0
 */
function updateQRCodeStatus(status) {
	QRCodeEnabled = status;

	updateConfigurationRecap();
}
